import { Group, Text } from '@mantine/core';
import { View } from 'react-big-calendar';
import dayjs from 'dayjs';
import { useMemo } from 'react';
import classes from './SchedulingCalendarToolbar.module.css';

export type CalendarDateTitleProps = {
  view: View;
  date: Date;
};

export default function CalendarDateTitle({ view, date }: CalendarDateTitleProps) {
  const formattedDate = useMemo(() => {
    if (view !== 'day') {
      return {
        month: dayjs(date).format('MMMM'),
        year: dayjs(date).format('YYYY'),
      };
    }
    return {
      month: dayjs(date).format('MMMM'),
      year: dayjs(date).format('YYYY'),
      day: view === 'day' ? dayjs(date).format('D') : undefined,
    };
  }, [view, date]);

  return (
    <Group gap={0}>
      <Text className={classes.dateTitleInfo}>{formattedDate.month}</Text>
      {formattedDate.day && (
        <Text className={`${classes.dateTitleInfo} ${classes.dateTitleInfoTiny}`}>{formattedDate.day}</Text>
      )}
      <Text className={`${classes.dateTitleInfo} ${classes.dateTitleInfoTiny}`}>{formattedDate.year}</Text>
    </Group>
  );
}
